import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "./SignIn.css"; // Import the CSS file

const SignIn = ({ setUserRole }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // Firebase Auth login
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Fetch additional user details from Firestore
      const fetchUserData = async (uid) => {
        try {
          const userDoc = await getDoc(doc(db, "users", uid)); // Fetch document with uid as ID
          if (userDoc.exists()) {
            return userDoc.data(); // Return user data
          } else {
            throw new Error("No such user data in Firestore!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          throw error;
        }
      };

      const userData = await fetchUserData(userId); // Fetch user data
      setUserRole(userData.role); // Set user role in the parent component
      navigate("/"); // Redirect to Home
    } catch (err) {
      setError("Invalid email or password. Please try again.");
      console.error("Sign-in error:", err);
    }
  };

  return (
    <div className="sign-in-container">
      <div className="sign-in-box">
        <img src="/logo.png" alt="Priority Pest Defense" className="logo" />
        <h1>Sign In</h1>
        <form onSubmit={handleSignIn}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Sign In</button>
        </form>
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default SignIn;